import "./App.css";
import { useEffect, useState } from "react";

import LoginPage from "./pages/loginPage/LoginPage.jsx";
import MainPage from "./pages/mainPage/MainPage.jsx";

function App() {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [user, setUser] = useState(null);

    useEffect(() => {

        if(localStorage.getItem("course-tracker-token")){
            getUserInfo();
            console.log("token already available")
        }

    }, []);

    const getUserInfo = async () => {

        const token = localStorage.getItem("course-tracker-token");

        if(!token) return;

        try {

            const response = await fetch(process.env.REACT_APP_ROOT_URL + "/user/me", {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": token
                }
            });

            //jksdl;ad

            if(!response.ok){
                const err = await response.text();
                throw new Error(err);
            }

            const {user} = await response.json();
            
            setUser(user);
            setIsLoggedIn(true);

        } catch (err) {
            console.log(err);
            localStorage.removeItem("course-tracker-token");
            setIsLoggedIn(false);
        }

    }

    const signOut = () => {

        setUser(null);
        setIsLoggedIn(false);
        localStorage.removeItem("course-tracker-token");

    }

	return (
    isLoggedIn ? 
    <MainPage user={user} setUser={setUser} signOut={signOut} getUserInfo={getUserInfo} /> 
    : 
    <LoginPage getUserInfo={getUserInfo} setIsLoggedIn={setIsLoggedIn} />
    );
}

export default App;
